import React from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import GenericSelect from '../../components/ui/GenericSelect';
import LoadErrorBanner from '../../components/ui/LoadErrorBanner';
import { useNineBoxProcesses } from '../nine-box/config';
import { PageWrap, FilterRow, Grid } from './styles';
import useTalentDashboardApi from './config';
import NineBoxDistributionCard from './components/NineBoxDistributionCard';
import PoolStatusCard from './components/PoolStatusCard';
import SuccessionCoverageCard from './components/SuccessionCoverageCard';
import IdpCompletionCard from './components/IdpCompletionCard';
import FlightRiskDistributionCard from './components/FlightRiskDistributionCard';

// Task 36 — TD İK/yönetim Dashboard'u, Task 24'ün GET v1/talent-dashboard
// ucunu (5 bileşen: NineBoxDistribution/PoolStatus/SuccessionCoverage/
// IdpCompletion/FlightRiskDistribution) tüketir. PrdPerformanceDashboardPage
// (Task 32) İLE AYNI desen: kart ızgarası, tema token'ları, üstte tek filtre
// (süreç seçici). Eski /v1/nine-box/grid çağrısı KALKTI — bu sayfa artık onu
// hiç çağırmıyor (Task 38 sökümünün ön şartıydı, bkz. nine-box/config yorumu).
export default function TalentDashboardPage() {
  const { t } = useTranslation();
  const { processes } = useNineBoxProcesses();
  const {
    processId, setProcessId, data, loading, loadFailed,
  } = useTalentDashboardApi();

  const processOptions = processes.map((p) => ({ id: p.id, name: p.name }));

  return (
    <PageWrap>
      <Breadcrumbs items={[{ label: t('menu.talentDashboard') }]} />

      <FilterRow>
        <GenericSelect
          label={t('talent.dashboard.processFilter')}
          value={processId}
          onChange={setProcessId}
          options={processOptions}
          idKey="id"
          labelKey="name"
          placeholder={t('talent.dashboard.autoLatestProcess')}
        />
      </FilterRow>

      {/* TD-23 — beş kartın da "veri yok" göstermesi ile okumanın BAŞARISIZ olması
          aynı şey değil; ikincisi artık açıkça söylenir. */}
      {loadFailed && <LoadErrorBanner />}

      <Grid>
        <NineBoxDistributionCard distribution={data.nineBoxDistribution} loading={loading} />
        <PoolStatusCard poolStatus={data.poolStatus} loading={loading} />
        <SuccessionCoverageCard coverage={data.successionCoverage} loading={loading} />
        <IdpCompletionCard completion={data.idpCompletion} loading={loading} />
        <FlightRiskDistributionCard distribution={data.flightRiskDistribution} loading={loading} />
      </Grid>
    </PageWrap>
  );
}
